export default __webpack_public_path__ + "static/media/clio-gallery-10.08be02b0.jpg";